export enum InvoicesTableStaticActionType {
  CancelInvoice = 'cancel_invoice',
  DeleteDraft = 'delete_draft',
  DownloadPDF = 'download_pdf',
  Duplicate = 'duplicate',
  Edit = 'edit',
  MarkAsSent = 'mark_as_sent',
  RegisterPayment = 'register_payment',
  SendAsEInvoice = 'send_as_e_invoice',
  SendByEmail = 'send_by_email',
  UnmarkAsSent = 'unmark_as_sent',
}
